import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { primeFeedData } from '../../utils/feedPrefetch';
import { API_BASE } from '../../config';

function AutoLogin() {
  const navigate = useNavigate();
  const { linkId = '' } = useParams();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    let isCancelled = false;

    const run = async () => {
      const key = searchParams.get('key') || '';

      if (!linkId || !key) {
        setError('Ссылка для автоматического входа неполная.');
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE}/api/Account/auto-login/${encodeURIComponent(linkId)}?key=${encodeURIComponent(key)}`,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || 'Не удалось выполнить автоматический вход.');
        }

        const data = await response.json();
        if (isCancelled) {
          return;
        }

        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data));
        primeFeedData();

        if (!data.isOnboardingCompleted) {
          navigate('/new-questionnaire', { replace: true });
        } else {
          navigate('/profile', { replace: true });
        }
      } catch (err) {
        if (!isCancelled) {
          setError(err.message || 'Не удалось выполнить автоматический вход.');
        }
      }
    };

    run();

    return () => {
      isCancelled = true;
    };
  }, [linkId, navigate, searchParams]);

  return (
    <main className="min-h-screen flex items-center justify-center">
      {error ? (
        <p className="log_in__error">{error}</p>
      ) : (
        <p>Выполняется вход...</p>
      )}
    </main>
  );
}

export default AutoLogin;
